import {createAsyncThunk} from '@reduxjs/toolkit';
import {AppThunkApiConfig} from '../../createStore';
import {FeatureToggle} from '../../data/entities';
import {mapiqApi} from '@lib/infrastructure';

export const loadEnabledFeatures = createAsyncThunk<FeatureToggle[], void, AppThunkApiConfig>(
  'features/loadEnabledFeatures',
  async (_, {extra}) => {
    const client = extra.apiClient;
    const api = mapiqApi(client);
    const enabledFeatures = await api.getEnabledFeatures();

    return enabledFeatures as FeatureToggle[];
  },
);
